import { useForm } from "react-hook-form"
import { FleContinueWrapper, FleLayout } from "../FleLayout"
import { BackArrow, ContinueArrow, SwitchH2ToBodyLarge } from "../Molecules"
import { Spacer } from "../../atoms/Atoms"
import React, { useEffect, useLayoutEffect, useState } from "react"
import L10n from "../../../../lib/carrot-l10n"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { Form } from "components/views/atoms/forms/Form"
import { regexes } from "utils/Regexes"
import { TopSection } from "../TopSection"
import { useHistory } from "react-router"
import useAboutYou from "../hooks/useAboutYou"
import { useAboutYouFlowControls } from "../context/AboutYouFlowContext"
import { AboutYouTopSection } from "components/carrot-plans/shared/ProgressTracker"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const AboutYourPartnerEmail = ({ next, previous }) => {
  const { register, handleSubmit, errors } = useForm()
  const history = useHistory()
  const { wentBack, goBack } = useAboutYouFlowControls()
  const { data, updateAboutYou, continueLoading } = useAboutYou()

  useLayoutEffect(() => {
    if (!wentBack && data?.partnerEmail) {
      history.push(next)
    }
  }, [history, wentBack, next, data?.partnerEmail])

  const [partnerEmail, setPartnerEmail] = useState(data?.partnerEmail || "")

  useEffect(() => {
    setPartnerEmail(data?.partnerEmail)
  }, [data?.partnerEmail])

  const submitPartnerEmail = async (data) => {
    await updateAboutYou(data)
    history.push(next)
  }

  return (
    <FleLayout
      closeButton
      bottomContent={
        <FleContinueWrapper>
          <ContinueArrow
            onClick={handleSubmit(submitPartnerEmail)}
            enabled={Boolean(partnerEmail) && !continueLoading}
          />
        </FleContinueWrapper>
      }
    >
      <Form onSubmit={Boolean(partnerEmail) && handleSubmit(submitPartnerEmail)}>
        <AboutYouTopSection previous={previous}>
          <TopSection progressStep={3} leftOrBackArrow={<BackArrow onClick={() => goBack(previous)} />} />
        </AboutYouTopSection>
        <SwitchH2ToBodyLarge>{l`What's your partner's email address?`}</SwitchH2ToBodyLarge>
        <Spacer height={3} />
        <CompleteFormInput
          name={"partnerEmail"}
          label={"Partner's email address"}
          value={partnerEmail}
          errors={errors}
          ref={register({
            pattern: {
              value: regexes.email,
              message: l`client.invalidEmail`
            },
            validate: {
              noWhitespace: (value) => value.length === value.trim().length || l`client.invalidEmail`
            }
          })}
          onChange={(e) => setPartnerEmail(e.target.value)}
        />
      </Form>
    </FleLayout>
  )
}

export { AboutYourPartnerEmail }
